import { render, staticRenderFns } from "./pImportItems.vue?vue&type=template&id=c9bd8f12&"
import script from "./pImportItems.vue?vue&type=script&lang=js&"
export * from "./pImportItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports